import messages from '../../../locale/messages';
import { inputTextLimit } from '../../../helpers/textRestriction';
import { isEuropeCountry } from '../../../helpers/europeCountryHelpers';

const validate = values => {

    const errors = {}

    if (!values.country) {
        errors.country = messages.required;
    } else if (values?.country?.length > inputTextLimit) {
        errors.country = messages.inputFieldRestriction;
    }

    if (!values.city) {
        errors.city = messages.required;
    } else if (values?.city?.length > inputTextLimit) {
        errors.city = messages.inputFieldRestriction;
    }

    if (!values.state) {
        errors.state = messages.required;
    } else if (values?.state?.length > inputTextLimit) {
        errors.state = messages.inputFieldRestriction;
    }

    if (!values.zipcode) {
        errors.zipcode = messages.required;
    } else if (values?.zipcode?.length > inputTextLimit) {
        errors.zipcode = messages.inputFieldRestriction;
    }

    if (!values.firstname || (values.firstname && values.firstname.toString().trim() == '')) {
        errors.firstname = messages.required;
    } else if (values?.firstname?.length > inputTextLimit) {
        errors.firstname = messages.inputFieldRestriction;
    }

    if (values.businessType && values.businessType === "individual" && (!values.lastname || (values.lastname && values.lastname.toString().trim() == ''))) {
        errors.lastname = messages.required;
    } else if (values?.businessType === "individual" && values?.lastname?.length > inputTextLimit) {
        errors.lastname = messages.inputFieldRestriction;
    }

    if (!values.routingNumber) {
        errors.routingNumber = messages.required;
    }

    if (!values.accountNumber) {
        errors.accountNumber = messages.required;
    } else if (values.accountNumber && values.accountNumber.toString().trim() === '') {
        errors.accountNumber = isEuropeCountry(values.country) ? messages.ibanNumberInvalid : (values.country === 'MX' ? messages.clabeNumberInvalid : messages.accountNumberInvalid);
    } else if (values?.accountNumber?.length > inputTextLimit) {
        errors.accountNumber = messages.inputFieldRestriction;
    }

    if (!values.confirmAccountNumber) {
        errors.confirmAccountNumber = messages.required;
    } else if (values.confirmAccountNumber && values.confirmAccountNumber.toString().trim() === '') {
        errors.confirmAccountNumber = isEuropeCountry(values.country) ? messages.confirmIbanNumberInvalid : (values.country === 'MX' ? messages.confirmClabeNumberInvalid : messages.confirmAccountNumberInvalid);
    }

    if (values.accountNumber && values.country === 'MX' && (values.accountNumber.length > 18 || isNaN(values.accountNumber))){
        errors.accountNumber = messages.clabeNumberInvalid;
    } 

    if (values.confirmAccountNumber && values.accountNumber) {
        if (values.confirmAccountNumber !== values.accountNumber) {
            errors.confirmAccountNumber = isEuropeCountry(values.country) ? messages.confirmIbanNumberMismatch :(values.country == 'MX' ? messages.confirmClabeNumberMismatch : messages.confirmAccountNumberMismatch);
        }
    } else if (values?.confirmAccountNumber?.length > inputTextLimit) {
        errors.confirmAccountNumber = messages.inputFieldRestriction;
    }

    if (values.country && values.country === 'US' && values.businessType && values.businessType === "individual") {
        if (!values.ssn4Digits) {
            errors.ssn4Digits = messages.required;
        } else if (values.ssn4Digits) {
            if (isNaN(values.ssn4Digits) || (parseInt(values.ssn4Digits, 10) < 1)) {
                errors.ssn4Digits = messages.ssn4DigitsInvalid;
            }
        }
    }
 
    if (!values.businessType) {
        errors.businessType = messages.required;
    }

    if (!values.bsbNumber) {
        errors.bsbNumber = messages.required;
    }

    if (!values.transitNumber) {
        errors.transitNumber = messages.required;
    }

    if (!values.institutionNumber) {
        errors.institutionNumber = messages.required;
    }

    if (!values.bankCode) {
        errors.bankCode = messages.required;
    }

    if (!values.accountOwnerName) {
        errors.accountOwnerName = messages.required;
    }

    if (!values.sortCode) {
        errors.sortCode = messages.required;
    }

    if (!values.branchCode) {
        errors.branchCode = messages.required;
    }

    if (!values.bankName) {
        errors.bankName = messages.required;
    }

    if (!values.branchName) {
        errors.branchName = messages.required;
    }

    return errors
}

export default validate;